<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-epigraph element-without-heading" epub:type="epigraph" id="epigraph">
<div class="text" id="epigraph-text">
<div class="alignment-block alignment-block-align-right">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-right epigraph-content">“If you don’t heal what hurt you, you’ll bleed on people who didn’t cut you.”</p>
<p class="alignment-block-content alignment-block-content-right epigraph-content">— Anonymous</p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?0660c0d5